<div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
    <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
        <h3 class="my-0">{{ 'USER.PLURAL' | translate }}</h3>

        <app-search-outline [searchInput]="searchInput"></app-search-outline>
    </div>

    <div class="w-100-p table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort [class.hidden]="!hasUsers">
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div class="relative" #avatarCell>
                        <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                        <ng-template #initials>
                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                        </ng-template>
                        <ng-template [onlineStateIndicator]="user.isOnline"></ng-template>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="firstName">
                <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                    {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user" class="narrow">
                    <p class="text-truncate">
                        {{ user.firstName }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="lastName">
                <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                    {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user" class="narrow">
                    <p class="text-truncate">
                        {{ user.lastName }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
                <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                    {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                    <p class="text-truncate">{{ user.email }}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(user)" *ngIf="!user.alreadyMember"></app-flat-button>
                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.alreadyMember"></app-white-button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple></mat-row>
        </mat-table>
        <mat-paginator persistPageSize="certification-provider.certificates-users-filter" [class.hidden]="!hasUsers" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>

        <ng-container *ngIf="!hasUsers">
            <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center" *ngIf="hasActiveSearch; else noUsersAvailableState">
                <mat-icon class="participant-view-illustration" svgIcon="search_no_results"></mat-icon>
                <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                <span>{{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}</span>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #noUsersAvailableState>
    <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="participant-view-illustration" svgIcon="user_illustration"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
    </div>
</ng-template>
